import { Component } from 'react'
import store from 'store'
import { Provider } from 'react-redux'
import EnabledColumns from './enabled_columns'

export default class EnabledColumnsApp extends Component {
  render () {
    return (
      <Provider store={store}>
        <EnabledColumns {...this.props} />
      </Provider>
    )
  }
}
